import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/esm/components/Container/Container.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Divider"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Divider/Divider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Group"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Group/Group.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Space"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Space/Space.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/DestinationCarouselSwiper/DestinationCarouselSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Error/Error404.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardsCarousel"] */ "/vercel/path0/src/components/SliceMachine/CardsCarousel/CardsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditableSliceWrapper"] */ "/vercel/path0/src/components/SliceMachine/EditableSliceWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SliceMachine/FullScreenImage/FullScreenImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SliceMachine/FullScreenImageHalf/FullScreenImageHalf.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GridPresentation"] */ "/vercel/path0/src/components/SliceMachine/GridPresentation/GridPresentation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HorizontalImageCard"] */ "/vercel/path0/src/components/SliceMachine/HorizontalImageCard/HorizontalImageCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HorizontalTextCard"] */ "/vercel/path0/src/components/SliceMachine/HorizontalTextCard/HorizontalTextCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalWithJsonPrompt"] */ "/vercel/path0/src/components/SliceMachine/ModalWithJsonPrompt.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SliceMachine/Quote/Quote.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["SquareCardList"] */ "/vercel/path0/src/components/SliceMachine/SquareCardList/SquareCardList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/SliceMachine/TextCard/TextCard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/SliceMachine/VerticalCardList/VerticalCardList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Title/Title.module.scss");
